import { SVGProps } from 'react';

interface CustomSVGProps extends SVGProps<SVGSVGElement> {
  fillColor1?: string;
  fillColor2?: string;
  r?: string;
}

const IconSavedLeadRealEstateWithGuestReportModule = (props: CustomSVGProps) => {
  const { fillColor1, fillColor2, r, ...restProps } = props;

  return (
    <svg
      width='55'
      height='55'
      viewBox='0 0 55 55'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...restProps}
    >
      <g clipPath='url(#clip0_161_31023)'>
        <rect width='55' height='55' rx='8' fill='white' />
        <rect width='55' height='55' rx='8' fill='url(#paint0_linear_161_31023)' />
        <rect width='55' height='55' rx='8' fill={fillColor1 ?? '#ECECEC'} />
        <circle
          opacity='0.6'
          cx='44.6111'
          cy='48.5'
          r='30'
          fill='url(#paint1_radial_161_31023)'
          fillOpacity='0.8'
        />
        <path
          d='M38.1791 17.0212C38.0016 16.9789 37.8149 17.0017 37.6527 17.0854L36.5001 17.661L35.3376 17.0797C35.2334 17.0277 35.1186 17.0006 35.0022 17.0006C34.8857 17.0006 34.7709 17.0277 34.6668 17.0797L33.4897 17.6615L32.3282 17.0797C32.2237 17.0273 32.1085 17 31.9916 17C31.8748 17 31.7595 17.0273 31.6551 17.0797L30.5001 17.6596L29.354 17.0812C29.2498 17.0283 29.1348 17.0006 29.018 17.0001C28.9012 16.9996 28.7859 17.0264 28.6813 17.0783L27.5001 17.6619L26.3376 17.0793C26.2332 17.0272 26.1183 17.0001 26.0017 17.0001C25.8851 17.0001 25.7702 17.0272 25.6658 17.0793L24.5001 17.661L23.3357 17.0793C23.1856 17.004 23.0146 16.9813 22.85 17.0148C22.6855 17.0483 22.5369 17.136 22.4282 17.264C22.311 17.4037 22.2478 17.5808 22.2501 17.7632V29.0001L22.2524 29.0024H31.2501C31.6479 29.0024 32.0294 29.1604 32.3107 29.4417C32.592 29.723 32.7501 30.1046 32.7501 30.5024V35.3751C32.7501 36.8249 34.3002 38.0001 35.7501 38.0001H36.3126C36.959 38.0001 37.579 37.7433 38.0361 37.2861C38.4933 36.829 38.7501 36.209 38.7501 35.5626V17.7501C38.7502 17.5822 38.694 17.4191 38.5905 17.287C38.487 17.1548 38.3421 17.0612 38.1791 17.0212ZM35.0001 26.7501H29.0235C28.6185 26.7501 28.2688 26.4388 28.251 26.0338C28.2464 25.9326 28.2624 25.8315 28.298 25.7366C28.3336 25.6418 28.388 25.5551 28.458 25.4819C28.528 25.4086 28.6122 25.3503 28.7053 25.3105C28.7985 25.2706 28.8987 25.2501 29.0001 25.2501H34.9766C35.3816 25.2501 35.7313 25.5613 35.7491 25.9663C35.7537 26.0675 35.7377 26.1686 35.7021 26.2635C35.6665 26.3583 35.6121 26.445 35.5421 26.5183C35.4721 26.5915 35.388 26.6498 35.2948 26.6896C35.2016 26.7295 35.1014 26.75 35.0001 26.7501ZM35.0001 23.0001H26.0235C25.6185 23.0001 25.2688 22.6888 25.251 22.2838C25.2464 22.1826 25.2624 22.0815 25.298 21.9866C25.3336 21.8918 25.388 21.8051 25.458 21.7319C25.528 21.6586 25.6122 21.6003 25.7053 21.5605C25.7985 21.5206 25.8987 21.5001 26.0001 21.5001H34.9766C35.3816 21.5001 35.7313 21.8113 35.7491 22.2163C35.7537 22.3175 35.7377 22.4186 35.7021 22.5135C35.6665 22.6083 35.6121 22.695 35.5421 22.7683C35.4721 22.8415 35.388 22.8998 35.2948 22.9396C35.2016 22.9795 35.1014 23 35.0001 23.0001Z'
          fill={fillColor2 ?? '#80888F'}
        />
        <path
          d='M31.25 35.375V31.25C31.25 31.0511 31.171 30.8603 31.0303 30.7197C30.8897 30.579 30.6989 30.5 30.5 30.5H17.75C17.3522 30.5012 16.971 30.66 16.6899 30.9415C16.4088 31.2231 16.2506 31.6045 16.25 32.0023C16.25 34.3719 16.5209 35.3572 16.9278 36.1072C17.6183 37.3808 18.8684 38 20.75 38H32.2663C32.3032 38 32.3394 37.9891 32.3702 37.9686C32.401 37.9481 32.4251 37.919 32.4394 37.8849C32.4536 37.8508 32.4575 37.8132 32.4505 37.7769C32.4435 37.7405 32.4258 37.7071 32.3998 37.6808C31.9564 37.2359 31.25 36.6406 31.25 35.375Z'
          fill={fillColor2 ?? '#80888F'}
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_161_31023'
          x1='50.1111'
          y1='51.9444'
          x2='4.88888'
          y2='4.27777'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#9DBFE8' />
          <stop offset='1' stopColor='#97A9B0' />
        </linearGradient>
        <radialGradient
          id='paint1_radial_161_31023'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(44.6111 48.5) rotate(90) scale(30)'
        >
          <stop stopColor='white' stopOpacity='0.2' />
          <stop offset='0.890625' stopColor='white' stopOpacity='0.83' />
        </radialGradient>
        <clipPath id='clip0_161_31023'>
          <rect width='55' height='55' rx='8' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export { IconSavedLeadRealEstateWithGuestReportModule };
